"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatImageUrl = exports.TypedOptions = exports.TypedFilter = exports.BaseFilter = exports.NumberRange = exports.DateFilter = exports.PaginationOptions = exports.IsDateOrConvertible = exports.createFieldPath = void 0;
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
const createFieldPath = (path) => path;
exports.createFieldPath = createFieldPath;
function IsDateOrConvertible(validationOptions) {
    return function (object, propertyName) {
        (0, class_validator_1.registerDecorator)({
            name: "isDateOrConvertible",
            target: object.constructor,
            propertyName: propertyName,
            options: validationOptions,
            validator: {
                validate(value, _args) {
                    return (value instanceof Date ||
                        typeof value === "string" ||
                        typeof value === "number");
                },
                defaultMessage(args) {
                    return `${args.property} must be a Date, string, or number`;
                },
            },
        });
    };
}
exports.IsDateOrConvertible = IsDateOrConvertible;
class PaginationOptions {
}
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.Max)(100),
    __metadata("design:type", Number)
], PaginationOptions.prototype, "limit", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], PaginationOptions.prototype, "page", void 0);
exports.PaginationOptions = PaginationOptions;
class DateFilter {
}
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.Validate)(IsDateOrConvertible),
    __metadata("design:type", Object)
], DateFilter.prototype, "from", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.Validate)(IsDateOrConvertible),
    __metadata("design:type", Object)
], DateFilter.prototype, "to", void 0);
exports.DateFilter = DateFilter;
class NumberRange {
}
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], NumberRange.prototype, "min", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], NumberRange.prototype, "max", void 0);
exports.NumberRange = NumberRange;
class BaseFilter {
}
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ each: true }),
    __metadata("design:type", Object)
], BaseFilter.prototype, "id", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ each: true }),
    __metadata("design:type", Object)
], BaseFilter.prototype, "createdBy", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ each: true }),
    __metadata("design:type", Object)
], BaseFilter.prototype, "updatedBy", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ each: true }),
    __metadata("design:type", Object)
], BaseFilter.prototype, "deletedBy", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], BaseFilter.prototype, "isDeleted", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], BaseFilter.prototype, "isActive", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.Validate)(DateFilter),
    __metadata("design:type", DateFilter)
], BaseFilter.prototype, "createdAt", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.Validate)(DateFilter),
    __metadata("design:type", DateFilter)
], BaseFilter.prototype, "updatedAt", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.Validate)(DateFilter),
    __metadata("design:type", DateFilter)
], BaseFilter.prototype, "deletedAt", void 0);
exports.BaseFilter = BaseFilter;
class TypedFilter extends BaseFilter {
}
exports.TypedFilter = TypedFilter;
class TypedOptions extends PaginationOptions {
    validate() {
        const errors = (0, class_validator_1.validateSync)(this);
        return errors.map((error) => { var _a; return Object.values((_a = error.constraints) !== null && _a !== void 0 ? _a : {}); }).flat();
    }
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    static fromPlain(plain) {
        return (0, class_transformer_1.plainToClass)(TypedOptions, plain);
    }
    static toPlain(entity) {
        return (0, class_transformer_1.instanceToPlain)(entity);
    }
}
exports.TypedOptions = TypedOptions;
function isValidUrl(url) {
    try {
        new URL(url);
        return true;
    }
    catch {
        return false;
    }
}
function formatImageUrl(src) {
    if (!src) {
        return null;
    }
    // Return as-is if it's already an absolute URL
    if (isValidUrl(src)) {
        return src;
    }
    // Return as-is if it's a data URL
    if (src.startsWith("data:")) {
        return src;
    }
    if (src.startsWith("/assets")) {
        return src;
    }
    const domain = process.env.NEXT_PUBLIC_S3_URL;
    // Ensure src has a leading slash
    const normalizedSrc = src.startsWith("/") ? src : `/${src}`;
    // Combine domain with normalized path
    return `${domain}${normalizedSrc}`;
}
exports.formatImageUrl = formatImageUrl;
